import React from 'react';
import {
  Button,
  GroupedElements,
  GroupedElementsItem,
  Flashy,
  Icon,
  Loader,
  SlidingText,
  Tooltip,
} from '@axiom/ui';

import type { ChatHistoryItem } from '../../api/chat-api';
import { ChatState } from '../../enums/chat-state';

import { ChatHistoryRowMenu } from './ChatHistoryRowMenu';

export type ChatHistoryRowProps = {
  chat: ChatHistoryItem;
  isActive: boolean;
  isMoving: boolean;
  hide: () => Promise<void>;
  unhide: () => Promise<void>;
  setActiveChatId: ({
    chatId,
    isFull,
  }: {
    chatId: string | null;
    isFull?: boolean;
  }) => void;
  startRename: () => void;
};

export const ChatHistoryRow = ({
  chat,
  isActive,
  isMoving,
  hide,
  unhide,
  setActiveChatId,
  startRename,
}: ChatHistoryRowProps) => {
  const chatName = chat.name || 'Untitled chat';

  const isFull = chat.chatState === ChatState.CONTEXT_WINDOW_EXCEEDED;

  return (
    <GroupedElements current fluid name={`CHAT_ROW_${chat.id}`} size="small">
      {isFull ? (
        <Tooltip
          anchor={
            <Flashy color="dataVizYellow" name={`CHAT_FULL_${chat.id}`}>
              <Icon name="circle-info" />
            </Flashy>
          }
          hideClose
          name={`CHAT_FULL_EXPLANATION_${chat.id}`}
          position="right"
        >
          This chat is full. You can still read it, but not add to it.
        </Tooltip>
      ) : null}

      <GroupedElementsItem fluid>
        <Button
          alignContent="left"
          disabled={isActive || isMoving}
          name={`CHAT_OPEN_${chat.id}`}
          onClick={() => {
            setActiveChatId({ chatId: chat.id, isFull });
          }}
          variation="minimal"
        >
          <SlidingText name={`CHAT_NAME_${chat.id}`}>{chatName}</SlidingText>
        </Button>
      </GroupedElementsItem>
      <GroupedElementsItem
        name={`CHAT_ACTIONS_SLOT_${chat.id}`}
        overlay
        revealed={isMoving}
      >
        {isMoving ? (
          <Loader name={`CHAT_MOVING_${chat.id}`} type="dots" />
        ) : (
          <ChatHistoryRowMenu
            chat={chat}
            hide={hide}
            startRename={startRename}
            unhide={unhide}
          />
        )}
      </GroupedElementsItem>
    </GroupedElements>
  );
};
